import React from "react";
import FullMenu from "../assets/menu/fullmenu.pdf";
import Category from "../components/menu-categories";
import Dish from "../components/menu-dish";
import MenuItems from "../data/menu-items";
import Drink from "../img/drink.jpg";
import Hauptgericht from "../img/hauptgerichte.jpg";
import MenuIntro from "../img/menuintro.jpg";
import Vorspeise from "../img/vorspeisen.jpg";

class Menu extends React.Component {
  constructor() {
    super();
    this.state = { category: "vor" };
    // console.log(MenuItems())
  }

  renderMenuContent() {
    var category = this.state.category;

    return MenuItems()[category].map((dish) => {
      return (
        <Dish
          key={dish.title}
          img={dish.img}
          title={dish.title}
          description={dish.description}
        />
      );
    });
  }

  render() {
    return (
      <div>
        <div
          style={{
            backgroundImage: "url(" + MenuIntro + ")",
            backgroundRepeat: "no-repeat",
            height: "30vh",
            backgroundPosition: "center",
            backgroundSize: "cover",
            display: "flex",
            textAlign: "center",
            // filter: "brightness(30%)"
          }}
        >
          <div className="menu--title">
            <h1 style={{ color: "white" }}>Unser Menü im Überblick</h1>
          </div>
        </div>
        <div className="menu" id="menu">
          <div className="menu--header">
            <a onClick={() => this.setState({ category: "vor" })}>
              <Category img={Vorspeise} title="Vorspeise" />
            </a>

            <a onClick={() => this.setState({ category: "haupt" })}>
              <Category img={Hauptgericht} title="Hauptgerichte" />
            </a>

            <a onClick={() => this.setState({ category: "cock" })}>
              <Category img={Drink} title="Cocktails" />
            </a>
          </div>

          <div className="menu--content">{this.renderMenuContent()}</div>

          <div style={{ textAlign: "center" }}>
            <br />
            <a href={FullMenu} target="_blank" style={{ color: "black" }}>
              <li>
                <input
                  type="submit"
                  value="Vollständiges Menü"
                  className="special black-border"
                />
              </li>
            </a>
            {/* <a href={MittagMenu} target="_blank" style={{ color: "black" }}>
              <li>
                <input
                  type="submit"
                  value="Mittagsmenü"
                  className="special black-border"
                />
              </li>
            </a> */}
            {/* <a href={Empfehlung} target="_blank" style={{ color: "black" }}>
              <li>
                <input
                  type="submit"
                  value="Unsere Empfehlung"
                  className="special black-border"
                />
              </li>
            </a> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/menu.js